export const ScheduleTabsSkeleton = () => (
  <>
    {Array.from({ length: 7 }, (_, index) => (
      <span className="skeleton-block h-9.25 min-w-18.5 rounded-lg" key={index} />
    ))}
  </>
);

export const ScheduleCardsSkeleton = () => (
  <>
    {Array.from({ length: 4 }, (_, groupIndex) => (
      <div className="schedule-time-group grid gap-3" aria-hidden="true" key={groupIndex}>
        <div className="schedule-time-skeleton">
          <span className="skeleton-block" />
        </div>
        <div className="schedule-time-slot grid gap-2">
          <div className="skeleton-block schedule-broadcast-skeleton" />
          <div className="schedule-time-subjects grid gap-2.5">
            {Array.from({ length: 3 }, (_, itemIndex) => (
              <div className="schedule-subject-item flex min-w-0 items-center gap-3 py-1" key={itemIndex}>
                <div className="skeleton-block schedule-subject-cover" />
                <div className="schedule-subject-copy grid min-w-0 flex-1 gap-1">
                  <div className="skeleton-block schedule-title-skeleton" />
                  <div className="skeleton-block schedule-subtitle-skeleton" />
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    ))}
  </>
);
